var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/muhammadzainanjum/Documents/deinepflege/deinepflege/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/components/organisms/faq-overview/faq-overview.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "\n\n  <div class=\"faq__accordion\">\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"length") < 1) {
output += "\n    <div class=\"faq__accordion__no-results\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "labels")),"no_results"), env.opts.autoescape);
output += "</div>\n    ";
;
}
output += "\n    <div class=\"accordion accordion--multiple\">\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n      ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loadMore")),"steps") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") > runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loadMore")),"steps"))) {
output += "\n        ";
var t_5;
t_5 = "hidden-item";
frame.set("itemClass", t_5, true);
if(frame.topLevel) {
context.setVariable("itemClass", t_5);
}
if(frame.topLevel) {
context.addExport("itemClass", t_5);
}
output += "\n      ";
;
}
else {
output += "\n        ";
var t_6;
t_6 = "show-item";
frame.set("itemClass", t_6, true);
if(frame.topLevel) {
context.setVariable("itemClass", t_6);
}
if(frame.topLevel) {
context.addExport("itemClass", t_6);
}
output += "\n      ";
;
}
output += "\n\n\n      <div class=\"accordion__item ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "itemClass"), env.opts.autoescape);
output += "\">\n        <div class=\"accordion__item__inner\">\n        <button class=\"accordion__toggle\" type=\"button\"><span class=\"accordion__toggle__title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"attributes")),"question"), env.opts.autoescape);
output += "</span><span class=\"accordion__toggle__icon\"><svg class=\"icon icon--plus\" viewBox=\"0 0 200 200\" aria-hidden=\"true\">\n          <use xlink:href=\"#icon-plus\"></use>\n        </svg><svg class=\"icon icon--minus\" viewBox=\"0 0 200 200\" aria-hidden=\"true\">\n          <use xlink:href=\"#icon-minus\"></use>\n        </svg></span></button>\n          <div class=\"accordion__panel\">\n            <div class=\"text\">\n              ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("markdown").call(context, runtime.memberLookup((runtime.memberLookup((t_4),"attributes")),"answer"))), env.opts.autoescape);
output += "\n\n              ";
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"attributes")),"faqCta")),0);
frame.set("cta", t_7, true);
if(frame.topLevel) {
context.setVariable("cta", t_7);
}
if(frame.topLevel) {
context.addExport("cta", t_7);
}
output += "\n              ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cta")),"__component") == "faq-cta-elements.link") {
output += "\n                <a class=\"link link--inverted\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cta")),"url"), env.opts.autoescape);
output += "\"><span class=\"link__text\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cta")),"text"), env.opts.autoescape);
output += "</span></a>\n              ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cta")),"__component") == "faq-cta-elements.button") {
output += "\n                <a class=\"button button--secondary-inverted\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cta")),"url"), env.opts.autoescape);
output += "\"><svg class=\"icon icon--caret button__icon\" viewBox=\"0 0 200 200\" aria-hidden=\"true\">\n                  <use xlink:href=\"#icon-caret\"></use>\n                </svg><span class=\"button__text\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "cta")),"text"), env.opts.autoescape);
output += "</span></a>\n              ";
;
}
;
}
output += "\n\n            </div>\n          </div>\n        </div>\n      </div>\n\n\n    ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n\n  </div>\n  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loadMore")),"steps") < env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "data"))) {
output += "\n  <div class=\"faq__button\"><button class=\"button button--secondary\" type=\"button\"><svg class=\"icon icon--caret button__icon\" viewBox=\"0 0 200 200\" aria-hidden=\"true\">\n        <use xlink:href=\"#icon-caret\"></use>\n      </svg><span class=\"button__text\">Mehr laden</span></button></div>\n  ";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/components/organisms/faq-overview/faq-overview.njk"] , dependencies)